/**
 * @module cercaliagl/view/VStreetView
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import $ from 'jquery';
import BaseView from './BaseView';
import { createIconButton } from './VUtils';
/**
 * @enum {string}
 */
export var EventType = {
    CLOSE: 'close',
};
/**
 * @classdesc
 */
var VStreetView = /** @class */ (function (_super) {
    __extends(VStreetView, _super);
    /**
     * @constructor
     */
    function VStreetView(options) {
        if (options === void 0) { options = {}; }
        var _this = this;
        var jqElement = $("\n    <div class=\"street-view-dialog mdc-elevation--z4\">\n      <div class=\"header\">\n        <span>".concat('Google maps - Street View', "</span>\n        <div class=\"closeBtn\">\n        ").concat(createIconButton('closeBtn', null, 'close'), "\n      </div>\n      </div>\n    </div>\n    "));
        _this = _super.call(this, jqElement) || this;
        /**
         * @private
         * @type {number}
         */
        _this.width = options.width ? options.width : 600;
        /**
         * @private
         * @type {number}
         */
        _this.height = options.height ? options.height : 480;
        jqElement.css('width', _this.width);
        jqElement.css('height', _this.height);
        jqElement.find('button.closeBtn').click(function () { return _this.emit(EventType.CLOSE); });
        _this.makePopupDraggable(jqElement);
        return _this;
    }
    /**
     * @private
     */
    // eslint-disable-next-line class-methods-use-this
    VStreetView.prototype.makePopupDraggable = function (jqElement) {
        var header = jqElement.find('.header');
        header.on('mousedown', function (e) {
            e.preventDefault();
            var startX = e.clientX;
            var startY = e.clientY;
            // Calcula el desplazamiento inicial en relación a la posición del documento
            var initialOffset = jqElement.offset();
            function mouseMoveHandler(mouseEvent) {
                var newLeft = mouseEvent.clientX - startX + initialOffset.left;
                var newTop = mouseEvent.clientY - startY + initialOffset.top;
                jqElement.offset({
                    left: newLeft,
                    top: newTop,
                });
            }
            $(document).on('mousemove', mouseMoveHandler);
            $(document).on('mouseup', function () {
                $(document).off('mousemove', mouseMoveHandler);
            });
        });
    };
    return VStreetView;
}(BaseView));
export default VStreetView;
//# sourceMappingURL=VStreetView.js.map